import { Backdrop, Box, CircularProgress, Grid, Typography, Card, CardContent, Rating } from '@mui/material';
import { useState } from 'react';
import { SubmitButton } from './SubmitButton';
import { registerEvaluation, ReviewInfo } from './RegisterEvaluation';
import { PageName, ReservationInfo } from './Index';

export function RatingSendForm(props: any) {
  const [open, setOpen] = useState(false);

  const [ratingValue, setRatingValue] = useState(0);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={0} md={3} sm={2} />
          <Grid item xs={12} md={6} sm={8}>
            <Grid container direction={'column'} spacing={2}>
              <Grid item xs={12} mt={2} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <Typography mb={2} pt={2} fontSize={'16px'} className="font-bold">
                  ご感想をお聞かせください。
                </Typography>
                <Typography mb={2} pt={2} fontSize={'14px'}>
                  本日はご来院いただき
                  <br />
                  誠にありがとうございました。
                </Typography>
                <Typography mb={2} pt={2} fontSize={'14px'}>
                  皆さまの声を大切にしております。
                  <br />
                  本日の診察についての
                  <br />
                  ご感想をお聞かせいただけますか。
                </Typography>
              </Grid>
            </Grid>
            <Grid container direction={'column'}>
              <Grid item xs={12} mt={2} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
                <Card sx={{ border: '1px solid #D6D3D0', borderRadius: '8px' }}>
                  <CardContent sx={{ padding: '16px !important' }}>
                    <Typography mb={2} fontSize={'14px'} color={'#A08B64'}>
                      あなたのご感想をお聞かせください
                    </Typography>
                    <Rating
                      sx={{ fontSize: '3.5em', color: '#FFB400 !important' }}
                      value={ratingValue}
                      onChange={(event, newValue) => {
                        let v = newValue || 0;
                        setRatingValue(v);
                        if (v > 0) {
                          setIsSubmitDisabled(false);
                        } else {
                          setIsSubmitDisabled(true);
                        }
                      }}
                    />
                  </CardContent>
                </Card>
                <SubmitButton
                  disabled={isSubmitDisabled}
                  label={'送信する'}
                  onClick={async () => {
                    if (ratingValue <= 0 || ratingValue > 5) return;
                    if (ratingValue === 5) {
                      setOpen(true);
                      const reviewInfo: ReviewInfo = {
                        evaluation: ratingValue,
                        q1answer: [],
                        q1other: '',
                        q2answer: [],
                        q2other: ''
                      };
                      await registerEvaluation(props.reservationInfo as ReservationInfo, reviewInfo);
                      props.setActivePage(PageName.AfterHigh);
                    } else {
                      props.toReviewPage(ratingValue);
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
